module.exports = __webpack_public_path__ + "img/qris-template.dde7209f.png";